module.exports = __webpack_public_path__ + "img/wechat.eb53b47e.jpeg";